export default "__VITE_ASSET__DI_5iz1V__"